export default "/images/vendor/flag-icon-css/flags/1x1/pf.svg?fbd548e641a7199e969d252cf9d1eb18";